module.exports = __webpack_public_path__ + "img/thatsaread-logo.2118164c.png";